const versionsNumber = {
    TRADE_360: 1,
    DILAWRI: 2,
};

const versionsName = {
    1: 'TRADE_360',
    2: 'DILAWRI',
};

export default versionsNumber;

export { versionsNumber, versionsName };
